import { Star } from 'lucide-react';
import { useMyFavorites, useAddFavorite, useRemoveFavorite } from '../../hooks/useMyHome';

interface Props {
  targetType: 'CHANNEL' | 'FILTER' | 'DOCUMENT' | 'IDEA';
  targetId: string;
  className?: string;
  size?: 'sm' | 'md';
}

export default function FavoriteToggle({ targetType, targetId, className = '', size = 'sm' }: Props) {
  const { data: favorites } = useMyFavorites(targetType);
  const addFavorite = useAddFavorite();
  const removeFavorite = useRemoveFavorite();

  const existing = favorites?.find((f) => f.targetId === targetId);
  const isFavorited = !!existing;

  const iconSize = size === 'sm' ? 'size-3.5' : 'size-4';

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (isFavorited && existing) {
      removeFavorite.mutate(existing.id);
    } else {
      addFavorite.mutate({ targetType, targetId });
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`p-0.5 rounded transition-colors shrink-0 ${className}`}
      title={isFavorited ? '즐겨찾기 해제' : '즐겨찾기 추가'}
    >
      <Star
        className={`${iconSize} ${
          isFavorited
            ? 'fill-yellow-400 text-yellow-400'
            : 'text-gray-300 hover:text-yellow-400'
        }`}
      />
    </button>
  );
}
